import { getCartCount, getSearchKeywords } from '@/api/module'
// 购物车
const state = {
  goods: null,
  goods_list: [],
  single_buy: false, // 是否为单品立即购买
  cartCount: '',
  keywords: ''
}

const mutations = {
  set_single_buy: (state, cartList) => {
    state.goods_list = cartList
  },
  SET_cartCount: (state, cartCount) => {
    state.cartCount = cartCount
  },
  SET_KEYWORDS: (state, keywords) => {
    state.keywords = keywords
  }
}

const actions = {
  getCartCount ({commit, state}) {
    return new Promise((resolve, reject) => {
      if (state.cartCount) {
        resolve(state.cartCount)
      } else {
        getCartCount().then(res => {
          commit('SET_cartCount', res.count)
          resolve()
        })
      }
    })
  },
  getSearchKeywords ({commit, state}) {
    return new Promise((resolve, reject) => {
      getSearchKeywords().then(res => {
        commit('SET_KEYWORDS', res.items)
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js